import { useParams } from 'react-router-dom';
import { Box, Container, Grid } from '@mui/material';
import { useEffect, useState } from 'react';

import PageTitleWrapper from 'src/components/PageTitleWrapper';
import PageHeader from 'src/components/pageHeader';
import Loader from 'src/components/Loader';
import NoDataFound from 'src/components/NoDataFound';

import DocumentsSection from './DocumentsSection';
import { useGetCaseDetailsMutation } from 'src/reduxServer/services/Cases';
import { useTranslation } from 'react-i18next';
import UploadDocumentDialog from 'src/content/pages/consultations/UploadDocumentDialog';
import { getRole } from 'src/utils/session';
import { Helmet } from 'react-helmet-async';

const CaseDocuments = () => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [openUpload, setOpenUpload] = useState(false)
  const role = getRole()
  const isLawyer = role[0] === "Lawyer"
  const isClient = role[0] === "Client"
  const [getCaseDetails, { data, isLoading, isError }] =
    useGetCaseDetailsMutation();

  useEffect(() => {
    if (id) {
      getCaseDetails(id);
    }
  }, [id, getCaseDetails]);

  const caseDetails = data?.case;
  const documents = caseDetails?.documents || [];

  if (isLoading) return <Loader />;
  if (isError || documents.length === 0) return (
    <Box sx={{ mt: 30 }}>
      <NoDataFound />
    </Box>
  );

  return (
    <>
      <Helmet>
        <title>Case Documents</title>
      </Helmet>
      <PageTitleWrapper>
        <PageHeader title={t("Documents List")}
          buttonLabel={(isLawyer || isClient) && t("Upload Document")}
          onButtonClick={() => setOpenUpload(true)}
        />
      </PageTitleWrapper>

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Grid container spacing={3}>
          {documents.map((doc: any) => (
            <Grid item xs={12} sm={6} md={4} key={doc.id}>
              <DocumentsSection doc={doc} />
            </Grid>
          ))}
        </Grid>
      </Container>

      <UploadDocumentDialog
        open={openUpload}
        onClose={() => setOpenUpload(false)}
        caseId={caseDetails?.id}
        refetchDocuments={() => id && getCaseDetails(id)}

      />

    </>
  );
};

export default CaseDocuments;
